<template>
    <div class="main-div">
        <el-row justify="end" class="headbar">
            <el-col :span="4" />
            <el-col :span="20">
                <el-form
                    :model="args"
                    class="search-form" :inline="true">
                    <el-form-item label="" prop="query" style="width: 250px;">
                        <el-input
                            v-model="args.query"
                            autocomplete="off"
                            placeholder=""
                            clearable
                            maxlength="32"
                            @change="load_data" />
                    </el-form-item>
                    <el-form-item style="width: 46px;">
                        <el-button
                            type="primary"
                            @click="load_data">
                            <el-icon><Search /></el-icon>
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row class="content">
            <el-table
                ref="elTable"
                v-loading="loading"
                style="height: 100%;"
                :data="data"
                :highlight-current-row="true"
                :border="true"
                :row-key="row => row.id"
                :expand-row-keys="expand_row_keys"
                :fit="true"
                @expand-change="on_expand_change">
                <el-table-column fixed type="index" :index="indexMethod" align="center" :min-width="80" />
                <el-table-column
                    v-for="(col, i) in tableCols"
                    :key="i"
                    :fixed="i < 2"
                    :label="col.label"
                    v-bind="col"
                    header-align="center"
                    :align="col.align" />
                <el-table-column />
            </el-table>
        </el-row>
        <el-row class="pagebar">
            <el-pagination
                align="center"
                :current-page="page"
                :page-sizes="[10,20,50,999]"
                :page-size="rspp"
                layout="total, sizes, prev, pager, next, jumper"
                :total="rcnt"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </el-row>
    </div>
    <DialogMachine ref="DialogMachine" />
</template>
<script>
import {notify} from '../../assets/js/utils.js';
import {try_catch} from '../../assets/js/async.js';
import {Search} from '@element-plus/icons-vue';
import DialogMachine from './dlg-task.vue';
import UserStore from '../../stores/user.js';

export default {
    name: 'TaskList',
    components: {
        Search,
        DialogMachine,
    },
    data: function() {
        return {
            args: {
                corp: '',
                query: '',
            },
            expand_row_keys: [],
            mach_list: null,
            data: [],
            page: 1, // 当前页码
            rspp: 20, // 每页的数据条数
            rcnt: NaN, // 总行数
            loading: true,
        };
    },
    computed: {
        userstore() {
            return UserStore();
        },
        tableCols() {
            return [
                {
                    prop: 'mach_name',
                    label: '机台',
                    width: 150,
                    align: 'center',
                },
                {
                    prop: 'order_code',
                    label: '单号',
                    width: 150,
                    align: 'center',
                },
                {
                    prop: 'task.product_name',
                    label: '产品',
                    width: 250,
                    align: 'center',
                },
                {
                    prop: 'record.quantity_qp',
                    label: '记录合格量',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'record.quantity_np',
                    label: '记录次品量',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'record.quantity_total',
                    label: '记录总产量',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'record.started_at',
                    label: '开始时间',
                    width: 180,
                    align: 'center',
                },
                {
                    prop: 'record.finished_at',
                    label: '结束时间',
                    width: 180,
                    align: 'center',
                },

                {
                    prop: 'task.planned_date',
                    label: '计划日期',
                    width: 120,
                    align: 'center',
                },
                {
                    prop: 'task.quantity_plan',
                    label: '计划产量',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'task.quantity_qp',
                    label: '合格量',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'task.quantity_np',
                    label: '次品量',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'task.quantity_total',
                    label: '总产量',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'state_name',
                    label: '状态',
                    width: 80,
                    align: 'center',
                },
                {
                    prop: 'task.created_at',
                    label: '创建时间',
                    width: 180,
                    align: 'center',
                },
                {
                    prop: 'task.updated_at',
                    label: '更新时间',
                    width: 180,
                    align: 'center',
                },
            ];
        },
    },
    beforeMount() {
        this.load_data();
    },
    onMounted() {
    },
    methods: {
        // on_expand_change(row, _children) {
        on_expand_change(row) {
            const key = row.id;
            const index = this.expand_row_keys.indexOf(key);
            if (index < 0) {
                this.expand_row_keys.push(key);
            } else {
                this.expand_row_keys.splice(index, 1);
            }
        },
        async add_item() {
            return await try_catch(async () => {
                const data = await this.$refs.DialogMachine.show({
                    data: { },
                    list: this.data,
                    machines: this.mach_list,
                });
                console.debug(data);
                this.load_data();
            });
        },
        async mod_item(_, row) {
            return await try_catch(async () => {
                const data = await this.$refs.DialogMachine.show({
                    data: JSON.parse(JSON.stringify(row)),
                    list: this.data,
                    machines: this.mach_list,
                });
                console.debug(data);
                this.load_data();
            });
        },
        async del_item(_, row) {
            return await try_catch(async () => {
                await this.$confirm(`确认要删除"${row.name}"`, '删除提示', {
                    iconClass: 'el-icon-question', // 自定义图标样式
                    confirmButtonText: '确认', // 确认按钮文字更换
                    cancelButtonText: '取消', // 取消按钮文字更换
                    showClose: true, // 是否显示右上角关闭按钮
                    type: 'warning', // 提示类型  success/info/warning/error
                });

                const url = `/api/tasks/${row.id}`;
                const res = await this.axios.delete(url);
                if (res.data?.result) {
                    notify('success', '删除成功', 999);
                } else {
                    notify('error', res.data.error);
                }
                this.load_data();
            });
        },
        async load_data() {
            this.loading = true;
            await try_catch(async () => {
                const url = `/api/records/`;
                const args = [['q', this.args.query], ['c', this.args.corp]].reduce((rs, [k, v]) => {
                    if (v) rs[k] = v;
                    return rs;
                }, {'page': this.page, 'rspp': this.rspp});
                const [mach_list, res] = await Promise.all([
                    this.load_machines(),
                    this.axios.get(url, {params: args})]);
                if (res.data.code && res.data.code !== 200 || res.data.error) {
                    notify('error', `加载列表失败 ${res.data.code || res.data.error}`);
                    console.error(res);
                    return;
                }
                const mach_dict = mach_list.reduce((r, x) => { r[x.id] = x; return r; }, {});
                const data = res.data.data;
                // console.log(mach_dict);
                data.forEach(item => {
                    item.state_name = item.task?.state && '活跃' || '冻结';
                    item.order_code = item.task?.order_code || item.record?.order_code;
                    const mach_id = item.task?.mach_id || item.record?.mach_id;
                    //  console.log(`mid: ${mach_id}`);
                    item.mach_name = mach_dict[mach_id]?.name;
                    // item.mach_name = mach_list.find(
                    //     m => m.id === (item.task.mach_id || item.record.mach_id),
                    // )?.name;
                });
                this.data.length = 0;
                this.data.push(...data);
            });
            this.loading = false;
        },
        async load_machines() {
            if (!this.mach_list) {
                const url = `/api/machines/`;
                const res = await this.axios.get(url);
                this.mach_list = res.data.data;
            }
            return this.mach_list;
        },
        indexMethod(index) {
            return index + (this.page - 1) * this.rspp + 1;
        },
        handleSizeChange(val) {
            this.page = 1;
            this.rspp = val;
            this.load_data();
        },
        // 当前页改变时触发 跳转其他页
        handleCurrentChange(val) {
            this.page = val;
            this.load_data();
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-div{
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    flex-direction: column;
}
.headbar {
}
.footbar {
}
.content {
    height: 100px;
    flex-grow: 1;
}
.search-form {
    text-align: right;
}
.search-form>.el-form-item {
    margin-bottom: 0;
    margin-right: 0;
    width: 150px;
}
</style>
